import * as React from 'react';

const ChevronDownIcon = ({width = 14, height = 14, ...props}) => (
  <svg
    viewBox="0 0 24 24"
    width={width}
    height={height}
    stroke="currentColor"
    strokeWidth={2}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export default ChevronDownIcon;
